import { MaterialIcon } from "./icon.js";
import { stylesheet } from "typestyle";
import { em } from "csx";
import * as React from 'react';
export function BackButton({ onClick, label }) {
    return (React.createElement("button", { onClick: onClick, className: styles.button },
        React.createElement("div", { className: styles.icon }, MaterialIcon.arrow_back),
        React.createElement("div", { className: styles.text }, label)));
}
const styles = stylesheet({
    button: {
        alignSelf: 'stretch',
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'center',
        border: 0,
        backgroundColor: 'transparent',
        padding: '0.5em 1em',
        cursor: "pointer"
    },
    icon: {
        fontSize: em(1.5)
    },
    text: {
        fontSize: em(0.75),
        textTransform: 'uppercase'
    }
});
//# sourceMappingURL=BackButton.js.map